import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { FC } from 'react';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { TradingAssistantButterflyChartInsight } from '@components/collections/trading-assistant-butterfly-chart/Model';
import { CollectionInsightType } from '@components/collections/Model';
import classnames from 'classnames';
import * as styles from '@components/opportunity-review-collection-button/OpportunityReviewCollectionButton.module.scss';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';

interface TACollectionButtonProps {
  isDisabled: boolean;
  createInsightDataFn: CreateInsightDataFn<TradingAssistantButterflyChartInsight>;
  createViewStateFn: CreateViewStateFn<any>;
}

const TACollectionButton: FC<TACollectionButtonProps> = ({ isDisabled, createInsightDataFn, createViewStateFn }) => {
  const pagesConfig = usePageConfig();

  return (
    <span
      className={classnames([
        {
          [styles.OpportunityReviewCollectionButton]: !isDisabled,
          [styles.OpportunityReviewCollectionButtonDisabled]: isDisabled,
        },
      ])}
    >
      <AddInsightToCollectionsButton<TradingAssistantButterflyChartInsight>
        type={CollectionInsightType.TradingAssistantButterflyChart}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
        createViewStateFn={createViewStateFn}
      />
    </span>
  );
};

export default TACollectionButton;
